<template>
  <div class="w-screen h-screen flex flex-row">
    <main-nav-bar class="w-[80px] flex-none" />

    <div class="flex-1 min-w-0 overflow-hidden">
      <digital-assets />
    </div>
  </div>
</template>

<script lang="ts" setup>
import MainNavBar from '@/shared/components/MainNavBar.vue'
import DigitalAssets from '@/modules/digitalAssets/DigitalAssets.vue'
</script>
